
    import '/opt/buildhome/repo/docs/spec/confirm-generation-process.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/docs/spec/confirm-generation-process.zh-CN.md?type=demo')
};